import React, { useEffect, useState } from "react";
import EpicComp from "../components/EpicComp";
import "./../epic.css";
import { connect } from "react-redux";
import { getNotesByPatientId, getSelectedPatientProfile } from "../actions/epicActions";
import { withRouter } from "react-router";

const EpicCont = ({ loggedInProviderDetails, epicCredDetails, history, userCredentails }) => {
   const patientId = epicCredDetails?.patientId;
   const [notesList, setNotesList] = useState(null);
   const [patientDetails, setPatientDetails] = useState(null);
   const [loader, setLoader] = useState(true);
   useEffect(() => {
      if (userCredentails.userCredentials === null) {
         history.push("/login");
      }
      if (patientId) {
         getNotes();
         getSelectedPatientProfile(patientId, (result) => {
            if (result) {
               setPatientDetails(result);
            }
         });
      }
   }, [patientId]);

   const getNotes = (initiateLoader = true) => {
      if (initiateLoader) {
         setLoader(true);
      }
      getNotesByPatientId(patientId, (result) => {
         if (result) {
            setNotesList(result?.data?.getNotes?.notes || []);
         }
         setLoader(false);
      });
   };
   return (
      <EpicComp
         setLoader={setLoader}
         getNotes={getNotes}
         patientId={patientId}
         notesList={notesList}
         patientDetails={patientDetails}
         epicCredDetails={epicCredDetails}
         loader={loader}
      />
   );
};
const mapStateToProps = (state) => {
   return {
      loggedInProviderDetails: state.auth?.loggedInProviderDetails,
      epicCredDetails: state.Epic?.epicCredDetails,
      userCredentails: state.auth,
   };
};

export default withRouter(connect(mapStateToProps, null)(EpicCont));
